export const P00061TemperatureType = [
  { ref: 15.0, label: '15.0 °C' },
  { ref: 16.0, label: '16.0 °C' },
  { ref: 17.0, label: '17.0 °C' },
  { ref: 18.0, label: '18.0 °C' },
  { ref: 19.0, label: '19.0 °C' },
  { ref: 20.0, label: '20.0 °C' },
  { ref: 21.0, label: '21.0 °C' },
  { ref: 22.0, label: '22.0 °C' },
  { ref: 23.0, label: '23.0 °C' },
  { ref: 24.0, label: '24.0 °C' },
  { ref: 25.0, label: '25.0 °C' },
  { ref: 26.0, label: '26.0 °C' },
  { ref: 27.0, label: '27.0 °C' },
  { ref: 28.0, label: '28.0 °C' },
  { ref: 29.0, label: '29.0 °C' },
  { ref: 30.0, label: '30.0 °C' },
  { ref: 31.0, label: '31.0 °C' },
  { ref: 32.0, label: '32.0 °C' },
  { ref: 33.0, label: '33.0 °C' },
  { ref: 34.0, label: '34.0 °C' },
  { ref: 35.0, label: '35.0 °C' },
];

export const P00061TemperatureTypeF = [
  { ref: 15.0, label: '59.0 °F' },
  { ref: 16.0, label: '60.8 °F' },
  { ref: 17.0, label: '62.6 °F' },
  { ref: 18.0, label: '64.4 °F' },
  { ref: 19.0, label: '66.2 °F' },
  { ref: 20.0, label: '68.0 °F' },
  { ref: 21.0, label: '69.8 °F' },
  { ref: 22.0, label: '71.6 °F' },
  { ref: 23.0, label: '73.4 °F' },
  { ref: 24.0, label: '75.2 °F' },
  { ref: 25.0, label: '77.0 °F' },
  { ref: 26.0, label: '78.8 °F' },
  { ref: 27.0, label: '80.6 °F' },
  { ref: 28.0, label: '82.4 °F' },
  { ref: 29.0, label: '84.2 °F' },
  { ref: 30.0, label: '86.0 °F' },
  { ref: 31.0, label: '87.8 °F' },
  { ref: 32.0, label: '89.6 °F' },
  { ref: 33.0, label: '91.4 °F' },
  { ref: 34.0, label: '93.2 °F' },
  { ref: 35.0, label: '95.0 °F' },
];
